function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import { buildThemeLogos } from "./utils/buildThemeLogos/buildThemeLogos";
import { buildThemeOptions } from "./utils/buildThemeOptions";
import { createBaseTheme } from "./utils/createBaseTheme";
export var createTheme = function createTheme(options) {
  var _options$palette$type, _options$palette;

  if (options === void 0) {
    options = {};
  }

  var themeOptions = buildThemeOptions(options);
  var baseTheme = createBaseTheme(themeOptions);
  var themeLogoDefinition = buildThemeLogos((_options$palette$type = (_options$palette = options.palette) == null ? void 0 : _options$palette.type) != null ? _options$palette$type : 'light');

  var theme = _extends({}, baseTheme, {
    logo: themeLogoDefinition // we have historically, and continue to here, trusted that createMuiTheme
    // keeps the additionally defined palette keys in our extended options

  });

  return theme;
};